import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-explainer',
  templateUrl: './explainer.component.html',
  styleUrls: ['./explainer.component.scss'],
})
export class ExplainerComponent implements OnInit {
  @Input()
  icon: string;
  @Input()
  title: string;
  @Input()
  description: string;

  constructor() {}

  ngOnInit() {}
}
